
export const validateEmail = (email: string) => {
	// eslint-disable-next-line
	const res = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return res.test(String(email).toLowerCase());
}

export const validateString = (str: string) => {
	return str.trim().length > 0
}

export const validatePhoneNumber = (number: string) => {
	var phonePattern = /^(\+39)?(0|3)\d{2,4}\d{6,8}$/;
	return phonePattern.test(number);
}

export const validateAlphaString = (value: string) => {
	return value.trim().length > 0;
}

export const validateProvince = (value: string) => {
	return validateAlphaString(value) && value.length === 2
}

export const validateCap = (value: string) => {
	var pattern = /^\d{5}$/;
	return pattern.test(value);
}

export const validateIdentityCard = (value?: string) => {
	if (value === undefined) return false;

	var pattern = /^[A-Za-z]{2}\d{5}[A-Za-z]{2}$/;
	var newCardTest = pattern.test(value);

	pattern = /^[A-Za-z]{2}\d{7}$/;
	var oldCardTest = pattern.test(value);
	return oldCardTest || newCardTest;
}

export const validateDrivingLicense = (value?: string) => {
	if (value === undefined) return false;
	var pattern = /^([A-Z]{2}\d{7}[A-Z])|(^[U]1[BCDEFGHLMNPRSTUWYXZ]\w{6}[A-Z])$/;
	return pattern.test(value);
}

export const validateFiscalCode = (value?: string) => {
	if (value === undefined) return false;
	var pattern = /^[A-Z]{6}\d{2}[A-EHLMPRST]\d{2}[A-Z]\d{3}[A-Z]$/;
	return pattern.test(value);
}

export const validateVatNumber = (value?: string) => {
	if (value === undefined) return false;
	var pattern = /^[0-9]{11}$/;
	return pattern.test(value);
}

export const validateSdi = (value?: string) => {
	if (value === undefined) return false;
	var pattern = /^[a-zA-Z0-9]{7}$/;
	return pattern.test(value);
}

export const validateIban = (iban: string) => {
	// L'iban è composto da una sigla di due lettere che indica il paese, due cifre di controllo e una parte variabile di cifre e lettere
	// L'iban deve essere convertito in un numero e sottoposto a una operazione di modulo 97 (come descritto nella norma ISO 7064)
	// Se l'iban è valido, il resto è uguale a 1
	// Controllare che la lunghezza totale dell'iban sia corretta in base al paese

	// Creo una variabile per il pattern dell'iban
	var pattern = /^[A-Z]{2}\d{2}[A-Z\d]{1,30}$/;

	// Testo l'iban con il pattern
	var result = pattern.test(iban);

	// Se il test è positivo, procedo con la conversione e il modulo 97
	if (result) {
		// Sposto le prime quattro lettere alla fine dell'iban
		var rearrangedIban = iban.slice(4) + iban.slice(0, 4);

		// Converto le lettere in numeri secondo la tabella ASCII
		// A = 10, B = 11, ..., Z = 35
		var convertedIban = "";
		for (var i = 0; i < rearrangedIban.length; i++) {
			var char = rearrangedIban[i];
			if (char >= "A" && char <= "Z") {
				var code = char.charCodeAt(0) - 55;
				convertedIban += code;
			} else {
				convertedIban += char;
			}
		}

		// Calcolo il modulo 97 del numero convertito
		var remainder = mod97(convertedIban);

		// Se il resto è uguale a 1, l'iban è valido
		if (remainder === 1) {
			result = true;
		} else {
			result = false;
		}
	}

	// Restituisco il risultato
	return result;
}

// Funzione per calcolare il modulo 97 di un numero molto grande
// Usa la proprietà che (a * 10 + b) mod m = ((a mod m) * 10 + b) mod m
function mod97(number: string) {
	var remainder = 0;
	for (var i = 0; i < number.length; i++) {
		var digit = parseInt(number[i]);
		remainder = (remainder * 10 + digit) % 97;
	}
	return remainder;
}
